import React from 'react';
import styled from 'styled-components';
import { rhythm } from "../../utils/typography";

const StyledH2 = styled.h2`
  position: relative;
  margin-top: ${rhythm(2.5)};
`;


const H2 = (props) => {
  return <StyledH2 {...props} />
}
export default H2;